module.exports = __webpack_public_path__ + "img/marca_sie.fa8854ff.png";